import { createGenericContext } from "../../../utils/createGenericContext";
export const [SelectedCiTypeContext, useSelectedCiTypeContext] = createGenericContext(null);
